import React from 'react';
import './FileExplorer.scss';
import './FileExplorerTable.scss'
import Sync from 'react-ionicons/lib/Sync';
import Document from 'react-ionicons/lib/Document';
import Folder from 'react-ionicons/lib/Folder';
import * as DriveHelper from '../../helpers/Drive';
import { T } from '../../helpers/Language';
import SkeletonBox from '../SkeletonBox/SkeletonBox';
import { Table } from 'react-bootstrap';
import { truncateFileName } from '../../helpers/Drive';

export const DFLT_ICO_PROPS = {
    height: '32px',
    width: '32px',
    color: 'inherit',
    className: 'type-ico'
};

export function FileSkeletonItem() {
    return (
        <tr className="file-element-item">
            <td className="item-type-icon">
                <SkeletonBox className="rounded d-flex align-items-center" style={{ width: 34, height: 31 }} />
            </td>
            <td>
                <SkeletonBox className="d-flex align-items-center" style={{ height: 24, width: '100%' }} />
            </td>
            <td>
                <SkeletonBox className="d-flex align-items-center" style={{ height: 24, width: '100%'}} />
            </td>
            <td>
                <SkeletonBox className="d-flex align-items-center" style={{ height: 24, width: '100%' }} />
            </td>
        </tr>
    )
}

export function FileSkeletonGroup() {
    return (
        <>
            <FileSkeletonItem />
            <FileSkeletonItem />
            <FileSkeletonItem />
            <FileSkeletonItem />
            <FileSkeletonItem />
        </>
    )
}


const ItemIcon = ({
    item,
    fileSelected
}) => {
    if (fileSelected &&
        item.id === fileSelected.id &&
        fileSelected._isFetching) {
        return <Sync {...DFLT_ICO_PROPS} rotate />;
    }
    return (
        item.reactType === 'folder' ?
            <Folder   {...DFLT_ICO_PROPS} /> :
            <Document {...DFLT_ICO_PROPS} />
    );
}

const FileExplorer = ({
    searchMode,
    // Data
    items, fileSelected, isLoading,
    // Methods
    onSelectFolder, onSelectFile,
}) => {
    const fileElements = (Array.isArray(items) ? items : []);
    return (
        <div className="file-explorer-module">
            <Table className="fe-table">
                <thead>
                    <tr>
                        <th style={{ width: 44 }}>&nbsp;</th>
                        <th>{T('DRIVE_FEXPLORER_FILE_NAME')}</th>
                        <th className='item-element-extension' style={{ width: 120 }}>{T('DRIVE_FEXPLORER_EXTENSION')}</th>
                        <th style={{ width: 220 }}>{searchMode ? T('DRIVE_FEXPLORER_FILE_LAST_UPDATE') : T('DRIVE_FEXPLORER_LAST_ACTIVITY')}</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading &&
                        <FileSkeletonGroup />
                    }
                    {!isLoading && fileElements.map((item) => (
                        <tr key={item.id}
                            className={['file-element-item item-animated', (fileSelected && fileSelected.id === item.id ? 'item-selected' : '')].join(' ')}
                            onClick={
                                item.reactType === 'folder' ?
                                    () => onSelectFolder(item.id) :
                                    () => onSelectFile(item.id)
                            }>
                            <td className="item-type-icon">
                                <ItemIcon item={item} fileSelected={fileSelected} />
                            </td>
                            <td>
                                {item.name && (
                                    <>
                                        {truncateFileName(item.name)}
                                    </>
                                )}
                                {!item.name && item.fileName && (
                                    <>
                                        {truncateFileName(item.fileName)}
                                    </>
                                )}
                            </td>
                            <td className='item-element-extension'>
                                {item.fileExtension || '-'}
                            </td>
                            <td>
                                {searchMode ?
                                    DriveHelper.FileElement.toHumaneReadableDate(item.updatedAt) :
                                    DriveHelper.FileElement.toLastActivity(item)
                                }
                            </td>
                        </tr>
                    ))}
                    {!isLoading && fileElements.length === 0 ?
                        <tr className="inactive">
                            <td style={{ height: 185 }} colSpan={12} className="text-center text-muted">
                                {T('DRIVE_FEXPLORER_NOTHING_TO_SHOW')}
                            </td>
                        </tr> : null
                    }
                </tbody>
            </Table>
        </div>
    );
};

export default FileExplorer;
